import { render, staticRenderFns } from "./HyperlinkForModulePermission.vue?vue&type=template&id=3f3f5b78&scoped=true&functional=true&"
import script from "./HyperlinkForModulePermission.vue?vue&type=script&lang=js&"
export * from "./HyperlinkForModulePermission.vue?vue&type=script&lang=js&"
import style0 from "./HyperlinkForModulePermission.vue?vue&type=style&index=0&id=3f3f5b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3f3f5b78",
  null
  
)

export default component.exports